import React from 'react';
import { motion } from 'framer-motion';
import { TECH_FEATURES } from '../../data/techFeatures';
import { HpbBatteryIcon } from './TechIcons';

export function HPBBattery() {
  const data = TECH_FEATURES.find(f => f.id === 'hpb');
  if (!data) return null;

  return (
    <section id="hpb" className="py-24 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-amber-100 text-amber-700 text-sm font-medium mb-4">
                Tecnología HPB
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                {data.title}
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-6">
                {data.description}
              </p>
            </div>

            {/* Benefits List */}
            <div className="space-y-4 pt-6 border-t border-gray-200">
              {data.benefits.map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
                      <path d="M2.5 6L5 8.5L9.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{item.title}</div>
                    <div className="text-gray-500 text-sm">{item.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Visual Side */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="relative flex items-center justify-center py-12"
          >
            {/* Background Decor */}
            <div className="absolute w-72 h-72 bg-gradient-to-br from-amber-100 to-orange-100 rounded-full blur-xl opacity-60" />
            <div className="absolute w-80 h-80 rounded-full border-2 border-dashed border-amber-200" />

            {/* Icon */}
            <motion.div
              className="relative z-10"
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <HpbBatteryIcon className="w-48 h-48 text-amber-500" />
            </motion.div>

            {/* Pulse Effect */}
            {[1, 2, 3].map((i) => (
              <motion.div
                key={i}
                className="absolute w-40 h-40 rounded-full border-2 border-amber-300"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{
                  scale: [0.8, 1.4],
                  opacity: [0.6, 0]
                }}
                transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  delay: i * 0.8,
                  ease: "easeOut"
                }}
              />
            ))}

            {/* Badge */}
            <motion.div
              className="absolute -top-4 right-10 bg-amber-500 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg z-20"
              initial={{ scale: 0, rotate: -10 }}
              whileInView={{ scale: 1, rotate: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              +25%
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
